namespace $ {
	export class $visavis_plot_plotly extends $mol_page {
		
		/**
		 * ```tree
		 * plot $visavis_plot
		 * ```
		 */
		@ $mol_mem
		plot() {
			const obj = new this.$.$visavis_plot()
			
			return obj
		}
		
		/**
		 * ```tree
		 * json *
		 * ```
		 */
		json() {
			return {
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * pages / <= Plot
		 * ```
		 */
		pages() {
			return [
				this.Plot()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * plot_options *
		 * 	displaylogo false
		 * 	displayModeBar false
		 * 	staticPlot false
		 * ```
		 */
		plot_options() {
			return {
				displaylogo: false,
				displayModeBar: false,
				staticPlot: false
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * plot_title \
		 * ```
		 */
		plot_title() {
			return ""
		}
		
		/**
		 * ```tree
		 * draw null
		 * ```
		 */
		draw() {
			return null as any
		}
		
		/**
		 * ```tree
		 * Root $mol_view auto <= draw
		 * ```
		 */
		@ $mol_mem
		Root() {
			const obj = new this.$.$mol_view()
			
			obj.auto = () => this.draw()
			
			return obj
		}
		
		/**
		 * ```tree
		 * error_showed? \
		 * ```
		 */
		@ $mol_mem
		error_showed(next?: any) {
			if ( next !== undefined ) return next as never
			return ""
		}
		
		/**
		 * ```tree
		 * Error $mol_view sub / <= error_showed?
		 * ```
		 */
		@ $mol_mem
		Error() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.error_showed()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * plot_body /
		 * 	<= Root
		 * 	<= Error
		 * ```
		 */
		plot_body() {
			return [
				this.Root(),
				this.Error()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Plot $mol_page
		 * 	title <= plot_title
		 * 	body <= plot_body
		 * ```
		 */
		@ $mol_mem
		Plot() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.plot_title()
			obj.body = () => this.plot_body()
			
			return obj
		}
	}
	
}

